<script lang="ts">
    import { Image } from "@unpic/svelte";
    import type { HTMLImgAttributes } from "svelte/elements";
    import { getPortrait } from "$lib/utils/images";

    interface Props extends Omit<HTMLImgAttributes, "src" | "alt" | "width" | "height"> {
        slug: string;
        alt: string;
        size?: number;
        width?: number;
        height?: number;
        /** Sets loading="eager" + fetchpriority="high" for above-the-fold images */
        priority?: boolean;
        class?: string;
    }

    let { slug, alt, size, width, height, priority, class: className = "rounded", ...rest }: Props = $props();

    const w = $derived(width ?? size ?? 36);
    const h = $derived(height ?? size ?? 36);

    let containerEl: HTMLSpanElement | undefined = $state();

    // Svelte 5 skips setting `src` on <img> during hydration to avoid
    // duplicate image loads. When settings change the hero list order
    // between prerender and hydration, the stale prerendered src sticks.
    // This effect forces the correct src onto the DOM element directly.
    $effect(() => {
        const img = containerEl?.querySelector("img");
        if (img) img.src = getPortrait(slug);
    });
</script>

<span bind:this={containerEl} class="contents">
    <Image
        src={getPortrait(slug)}
        {alt}
        width={w}
        height={h}
        layout="fixed"
        {priority}
        class={className}
        operations={{ cloudflare: { quality: 100 } }}
        {...rest}
    />
</span>
